// @flow weak

import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button
}                     from 'react-bootstrap';
import { withRouter }         from 'react-router';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions           from '../../redux/modules/actions';
// import AnimatedView   from '../../components/animatedView/AnimatedView';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../services/fetchTools';


function fakeLogin({ username }) {
  return new Promise(
    resolve => {
      setTimeout(
        () => resolve({ token: '1234567890123456', username }),
        200
      );
    }
  );
}

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      };
    this.handleSubmit = this.handleSubmit.bind(this);
    
  }
  static propTypes= {
    // react-router 4:
    match:    PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history:  PropTypes.object.isRequired,

    // views props:
    currentView: PropTypes.string.isRequired,

  };

  state = {
    email:          '',
    password:       '',
    isAuthenticating: false
  };

  componentDidMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Login');
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Login');
  }

  render() {
    const {
      email,
      password,
      isAuthenticating
    } = this.state;

    const{ user,history,isFetching, userInfos } = this.props;
    const {locationMenu} = this.props;

    console.log(user);

    if(isFetching != isAuthenticating){
      this.setState({ isAuthenticating: isFetching });      
    }

    if(user.data.isAuthenticated==true || user.data.isAuthenticated=='true'){
      localStorage.setItem('isAuthenticated', user.data.isAuthenticated);
      if(locationMenu.access_config != 'Technichal Partner'){
        history.push({ pathname: '/' }); // back to Home 
      }
      else{
        history.push({ pathname: '/' }); 
      }
           
      return null;
    }
    console.log(locationMenu);

    return (
      <div className="content">
        
            <form
              className="form-horizontal"
              noValidate>

                <img src={require("../../img/partner_background.jpeg")}

                                style={{
                                    flex: 1,
                                    height:'100%',
                                    width:'100%',
                                    position:'absolute'
                                }}

                                />
                <div className="login_circle">
                  <div style={{marginTop:'18%',marginLeft:'18%'}}>
                  <div style={{color:'#FDD60B',fontSize:18,fontWeight:'bold'}}>SIGN IN</div>
                  <div style={{color:'#2699FB',fontSize:14}}>Mobile</div>
                  <input
                      type="number"
                      style={{backgroundColor:'#FDD60B',width:'80%'}}
                      className="without_number form-control"
                      id="inputEmail"
                      placeholder="Mobile Number"
                      value={email}
                      onChange={this.handlesOnEmailChange}
                    />


                <div style={{marginTop:'10px'}}>
                <button className="btn btn-default" style={{width:'80%',backgroundColor: '#12037C', padding: '1%', borderColor: '#BCE0FD', borderWidth: '1px', width: '80%', alignSelf: 'center'}}
                type="button" onClick={this.handleSubmit}><span style={{color: '#ffffff'}}>Submit</span></button>            
                </div>
                

                {
                this.state.validate ?
                <div style={{marginTop: '10px'}}>

                 <div>
                  <div style={{color:'#2699FB',fontSize:14}}>OTP</div>
                  <input
                    type="password"
                    className="form-control"
                    style={{backgroundColor:'#FDD60B',width:'80%'}}
                    id="inputPassword"
                    placeholder="otp"
                    value={password}
                    onChange={this.handlesOnPasswordChange}
                  />
                </div>


                <div style={{marginTop:'10px'}}>
                    <Button
                      className="btn btn-default"
                      style={{width:'80%',backgroundColor: '#12037C', padding: '1%', borderColor: '#BCE0FD', borderWidth: '1px', width: '80%', alignSelf: 'center'}}
                      type="button"
                      disabled={isAuthenticating}
                      onClick={this.handlesOnLogin}>
                      {
                        isAuthenticating
                          ?
                          <span style={{color: '#ffffff'}}>
                            login in...
                            &nbsp;
                            <i
                              className="fa fa-spinner fa-pulse fa-fw"
                            />
                          </span>
                          :
                          <span style={{color: '#ffffff'}}>
                            Login
                          </span>
                      }
                    </Button>
                </div>
               </div> 
                :
                <div>
                </div>

               }
               <div className="form-group error" style={{alignSelf:'center',alignItem:'center'}}>
                  <span style={{textAlign:'center'}}>{user.data.error_message}</span>
                </div>  





                  </div>
                </div>             
                <div className="login_header">
                  <img src={require("../../img/sporthood-logo.png")}

                                style={{
                                    flex: 1,
                                    width:'90%',
                                    marginLeft:'8px',
                                    marginTop:'5px'
                                }}
                                />
                  <div style={{textAlign:'center',fontSize:28,color:'#190A80',fontWeight:'bold',marginTop:'-10px'}}>Partner Portal</div>
                  </div>           
            </form>
         
      </div>
    );
  }
  postMobile(mobile_no){
    const url = `${getLocationOrigin()}/auth/verify_mobile_start`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'mobile_no': mobile_no
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(response => this.setState({ validate: response.authentication}))
      .catch(error => {
        console.log(error);
        alert(error.message);
      });

  }
  handleSubmit(event){
    this.postMobile(this.state.email);

  }

  handlesOnEmailChange = (event) => {
    event.preventDefault();
    // should add some validator before setState in real use cases
    this.setState({ email: event.target.value.trim() });
  }

  handlesOnPasswordChange = (event) => {
    event.preventDefault();
    // should add some validator before setState in real use cases
    this.setState({ password: event.target.value.trim() });
  }

  handlesOnLogin = async (event) => {
    event.preventDefault();
    const {
      history
    } = this.props;

    const {
      email,
      password
    } = this.state;

    const user = {
      username: email,
      password: password
    };

    this.setState({ isAuthenticating: true });

    const { actions: { loginUser } } = this.props;    
    loginUser(email,password,'partner_portal');
    {/*
    try {
      await fakeLogin(user);
      this.setState({ isAuthenticating: false });
      history.push({ pathname: '/' }); // back to Home
    } catch (error) {

      this.setState({ isAuthenticating: false });
      console.log('login went wrong..., error: ', error);

    }
    */}
  }
}

const mapStateToProps = (state) => {
  return {
    userInfos:           state.userInfos.data,
    user:                state.user,
    locationMenu:        state.locationMenu
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {...actions},
      dispatch)
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);



// WEBPACK FOOTER //
// ./src/app/views/login/Login.js